export class EventsService {
    private getBackendBaseURL(): string {
        const w: any = window as any;
        return w._BACKEND_BASE_URL || import.meta.env.VITE_BACKEND_URL || 'http://localhost:3001';
    }

    private getAuthHeader(): Record<string, string> {
        const raw = (typeof window !== 'undefined' ? localStorage.getItem('backend_access_token') : '') || '';
        const token = raw.replace(/^"+|"+$/g, '').trim();
        const looksLikeJwt = token && token.split('.').length === 3;
        return looksLikeJwt ? { Authorization: `Bearer ${token}` } : {};
    }

    async logEvent(eventType: string, metadata: any = {}, callId?: string | null): Promise<void> {
        const url = `${this.getBackendBaseURL()}/events`;

        try {
            await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    ...this.getAuthHeader(),
                },
                credentials: 'include',
                body: JSON.stringify({
                    eventType,
                    metadata,
                    callId
                }),
            });
        } catch (error) {
            console.error(`[EventsService] Failed to log event ${eventType}:`, error);
        }
    }

    async getEventsByCallId(callId: string): Promise<any[]> {
        const url = `${this.getBackendBaseURL()}/events/call/${callId}`;
        try {
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    ...this.getAuthHeader(),
                },
            });
            if (!response.ok) {
                throw new Error(`Error fetching events: ${response.statusText}`);
            }
            return await response.json();
        } catch (error) {
            console.error(`[EventsService] Failed to fetch events for call ${callId}:`, error);
            return [];
        }
    }
}
